export const back = () => window.history.back();

export const isRepeated = (arr: string[], str: string) => {
  if (!arr.includes(str)) return false;
  const targetArr = [...arr];
  const newArr = targetArr.filter((_, idx, arr) => idx !== arr.indexOf(str));
  return newArr.includes(str);
};
